// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L4.2 8L11 1%27 stroke=%27white%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BarcodePrintModal_overlay__cPA4P {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.BarcodePrintModal_modal__nIZMB {
  text-align: left;
  background: white;
  border-radius: 10px;
  padding: 24px;
  width: 800px;
  overflow-y: auto;
}

.BarcodePrintModal_headingText__m9PgT {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
}

.BarcodePrintModal_headingSubtitle__b8oOn {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.BarcodePrintModal_headingSubtitle__b8oOn:last-child {
  margin-bottom: 0;
}

.BarcodePrintModal_headingSubtitle__b8oOn p {
  font-size: 16px;
}

.BarcodePrintModal_title__TKlsU {
  font-size: 24px;
  margin-bottom: 32px;
  font-weight: 700;
}

.BarcodePrintModal_content__o9sXZ {
  display: flex;
  gap: 20px;
}

.BarcodePrintModal_left__YsTZp {
  flex: 1 1;
}

.BarcodePrintModal_right__n69Iy {
  flex: 1 1;
  padding-left: 20px;
}

.BarcodePrintModal_preview__S7Dz6 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #f8f8f8;
  border-radius: 8px;
  height: 100%;
  padding: 11.5px;
  text-align: left;
}

.BarcodePrintModal_barcodeBox__OaHPc {
  margin-top: 12px;
}

.BarcodePrintModal_settings__j-hTy {
  margin-top: 20px;
}

.BarcodePrintModal_checkbox__HPIAE {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.BarcodePrintModal_footer__uLoiQ {
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
}

.BarcodePrintModal_cancel__S0VxN {
  background: none;
  padding: 10.5px 16px;
  margin-right: 8px;
  border: 1px solid rgba(115, 115, 115, 1);
  color: rgba(115, 115, 115, 1);
  border-radius: 4px;
}

.BarcodePrintModal_print__wgqvb {
  background: #1D8752;
  padding: 10.5px 16px;
  border: none;
  border-radius: 4px;
  color: white;
}

.BarcodePrintModal_barcodeBox__OaHPc {
  margin-top: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.BarcodePrintModal_filters__select__EEOxe:last-child {
  margin-top: 24px;
}

.BarcodePrintModal_box__3TdyC {
  display: block;
  width: 2px;
  height: 24px;
}

.BarcodePrintModal_checkboxContainer__2z1D7 {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  gap: 10px;
  margin: 22px 0;
}

.BarcodePrintModal_checkboxContainer__2z1D7 input {
  opacity: 0;
  position: absolute;
}

.BarcodePrintModal_customCheckbox__nu\\+Ht {
  width: 18px;
  height: 18px;
  background-color: white;
  border: 2px solid #1D8752;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.BarcodePrintModal_checkboxContainer__2z1D7 input:checked + .BarcodePrintModal_customCheckbox__nu\\+Ht {
  background-color: #1D8752;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
}

.BarcodePrintModal_checkboxLabel__IYpG\\+ {
  font-size: 14px;
  color: #333;
}

.BarcodePrintModal_textLabel__ZLnx\\+ {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;  
}

.BarcodePrintModal_rangeContainer__pvbUs {
  display: block;
  margin-bottom: 16px;
}

.BarcodePrintModal_rangeContainer__pvbUs:last-child {
  margin-bottom: 0;
}

.BarcodePrintModal_rangeContainer__pvbUs input[type="range"] {
  width: 100%;
  height: 6px;
  border-radius: 5px;
  background: linear-gradient(to right, #1D8752 0%, #ccc 0%);
  outline: none;
  transition: background 0.3s ease-in-out;
}

.BarcodePrintModal_rangeContainer__pvbUs input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1D8752;
  box-shadow: 0 0 0 2px white; 
  border: none;
  cursor: pointer;
  margin-top: -5px;
}

.BarcodePrintModal_rangeContainer__pvbUs input[type="range"]::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1D8752;
  border: none;
  cursor: pointer;
}

.BarcodePrintModal_rangeWrapper__BuC8y {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BarcodePrintModal_rangeValue__kTAzj {
  font-size: 14px;
  color: #333;
  min-width: 30px;
}

.BarcodePrintModal_rangeContainer__pvbUs input[type="range"]::-webkit-slider-thumb {
  margin-top: 1px;
}

.BarcodePrintModal_block__pWdax {
  padding: 24px;
  background: white;
}

.BarcodePrintModal_fontSize__rrJ73 {
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/BarcodePrintModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yDAAsO;EACtO,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,0DAA0D;EAC1D,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.modal {\n  text-align: left;\n  background: white;\n  border-radius: 10px;\n  padding: 24px;\n  width: 800px;\n  overflow-y: auto;\n}\n\n.headingText {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 16px;\n}\n\n.headingSubtitle {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.headingSubtitle:last-child {\n  margin-bottom: 0;\n}\n\n.headingSubtitle p {\n  font-size: 16px;\n}\n\n.title {\n  font-size: 24px;\n  margin-bottom: 32px;\n  font-weight: 700;\n}\n\n.content {\n  display: flex;\n  gap: 20px;\n}\n\n.left {\n  flex: 1;\n}\n\n.right {\n  flex: 1;\n  padding-left: 20px;\n}\n\n.preview {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #f8f8f8;\n  border-radius: 8px;\n  height: 100%;\n  padding: 11.5px;\n  text-align: left;\n}\n\n.barcodeBox {\n  margin-top: 12px;\n}\n\n.settings {\n  margin-top: 20px;\n}\n\n.checkbox {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 32px;\n}\n\n.cancel {\n  background: none;\n  padding: 10.5px 16px;\n  margin-right: 8px;\n  border: 1px solid rgba(115, 115, 115, 1);\n  color: rgba(115, 115, 115, 1);\n  border-radius: 4px;\n}\n\n.print {\n  background: #1D8752;\n  padding: 10.5px 16px;\n  border: none;\n  border-radius: 4px;\n  color: white;\n}\n\n.barcodeBox {\n  margin-top: 21px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.filters__select:last-child {\n  margin-top: 24px;\n}\n\n.box {\n  display: block;\n  width: 2px;\n  height: 24px;\n}\n\n.checkboxContainer {\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  gap: 10px;\n  margin: 22px 0;\n}\n\n.checkboxContainer input {\n  opacity: 0;\n  position: absolute;\n}\n\n.customCheckbox {\n  width: 18px;\n  height: 18px;\n  background-color: white;\n  border: 2px solid #1D8752;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.checkboxContainer input:checked + .customCheckbox {\n  background-color: #1D8752;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L4.2 8L11 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.checkboxLabel {\n  font-size: 14px;\n  color: #333;\n}\n\n.textLabel {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 16px;  \n}\n\n.rangeContainer {\n  display: block;\n  margin-bottom: 16px;\n}\n\n.rangeContainer:last-child {\n  margin-bottom: 0;\n}\n\n.rangeContainer input[type=\"range\"] {\n  width: 100%;\n  height: 6px;\n  border-radius: 5px;\n  background: linear-gradient(to right, #1D8752 0%, #ccc 0%);\n  outline: none;\n  transition: background 0.3s ease-in-out;\n}\n\n.rangeContainer input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #1D8752;\n  box-shadow: 0 0 0 2px white; \n  border: none;\n  cursor: pointer;\n  margin-top: -5px;\n}\n\n.rangeContainer input[type=\"range\"]::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #1D8752;\n  border: none;\n  cursor: pointer;\n}\n\n.rangeWrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rangeValue {\n  font-size: 14px;\n  color: #333;\n  min-width: 30px;\n}\n\n.rangeContainer input[type=\"range\"]::-webkit-slider-thumb {\n  margin-top: 1px;\n}\n\n.block {\n  padding: 24px;\n  background: white;\n}\n\n.fontSize {\n  margin-bottom: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `BarcodePrintModal_overlay__cPA4P`,
	"modal": `BarcodePrintModal_modal__nIZMB`,
	"headingText": `BarcodePrintModal_headingText__m9PgT`,
	"headingSubtitle": `BarcodePrintModal_headingSubtitle__b8oOn`,
	"title": `BarcodePrintModal_title__TKlsU`,
	"content": `BarcodePrintModal_content__o9sXZ`,
	"left": `BarcodePrintModal_left__YsTZp`,
	"right": `BarcodePrintModal_right__n69Iy`,
	"preview": `BarcodePrintModal_preview__S7Dz6`,
	"barcodeBox": `BarcodePrintModal_barcodeBox__OaHPc`,
	"settings": `BarcodePrintModal_settings__j-hTy`,
	"checkbox": `BarcodePrintModal_checkbox__HPIAE`,
	"footer": `BarcodePrintModal_footer__uLoiQ`,
	"cancel": `BarcodePrintModal_cancel__S0VxN`,
	"print": `BarcodePrintModal_print__wgqvb`,
	"filters__select": `BarcodePrintModal_filters__select__EEOxe`,
	"box": `BarcodePrintModal_box__3TdyC`,
	"checkboxContainer": `BarcodePrintModal_checkboxContainer__2z1D7`,
	"customCheckbox": `BarcodePrintModal_customCheckbox__nu+Ht`,
	"checkboxLabel": `BarcodePrintModal_checkboxLabel__IYpG+`,
	"textLabel": `BarcodePrintModal_textLabel__ZLnx+`,
	"rangeContainer": `BarcodePrintModal_rangeContainer__pvbUs`,
	"rangeWrapper": `BarcodePrintModal_rangeWrapper__BuC8y`,
	"rangeValue": `BarcodePrintModal_rangeValue__kTAzj`,
	"block": `BarcodePrintModal_block__pWdax`,
	"fontSize": `BarcodePrintModal_fontSize__rrJ73`
};
export default ___CSS_LOADER_EXPORT___;
